export enum CompanyRole {
  PARTNER = 'PARTNER',
  OWNED = 'OWNED'
}
